import { render, staticRenderFns } from "./rgTemplateQuestion.vue?vue&type=template&id=b67236a2&"
import script from "./rgTemplateQuestion.vue?vue&type=script&lang=ts&"
export * from "./rgTemplateQuestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports